import {StrengthEnum} from "@interfaces/common";

export interface Patient {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
}

export interface Doctor {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  patients_count: number;
  patients: Patient[];
}

export interface Report {
  field1: {
    actinobacteria: string;
    firmicutes: string;
    bacteroidetes: string;
    proteobacteria: string;
    other: string;
  },
  field2: {
    firmicutes: string;
    firmicutes1: string;
    firmicutes2: string;
    firmicutes3: string;
    firmicutes4: string;
    firmicutes5: string;
    firmicutes6: string;
    firmicutes7: string;
    firmicutes8: string;
    firmicutes9: string;
    firmicutes10: string;
  }
  relative_abundance: string;
  diversity_index: string;
  skin_age: string;
  skin_profile: {
    acne: StrengthEnum;
    skin_type: SkinTypeEnum;
    Pigmentation: StrengthEnum;
    Wrinkles: StrengthEnum;
  }
  skin_index: string;

}

export enum SkinTypeEnum {
  Noraml,
  Dry,
  Oily,
  Combination
}

export enum AccountTypeEnum {
  DOCTOR = 'DOCTOR',
  ADMIN = 'ADMIN',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  ANNOTATOR = 'ANNOTATOR',
  PATIENT = 'PATIENT',
}
